module.exports = __webpack_public_path__ + "media/bark02.904f93c5.mp3";